<script lang="ts" setup>
withDefaults(
  defineProps<{
    variant?: "red" | "darkblue";
    size?: "xs" | "s" | "m" | "l" | "xl";
  }>(),
  {
    variant: "red",
    size: "xl",
  },
);
</script>

<template>
  <div
    class="loading-spinner"
    :data-variant="variant"
    :data-size="size"
  ></div>
</template>

<style scoped>
@import "LoadingSpinner.css";
</style>
